export const OAuth2ErrorCode = {
    INVALID_GRANT: 'invalid_grant',
    INVALID_CLIENT: 'invalid_client',
    INVALID_TOKEN: 'invalid_token'
} as const;
